import { Delete, Get, Post, Put } from "./index"

export const loginAPI = async (payload: any) => {
    console.log(payload,"payload>>>>>");
    
    return Post({ url: `v1/auth/login`, payload })
  }
  
export const UserChangePasswordAPI = async (verifyData:any,payload: any) => {
    console.log(payload,"payload>>>>>");
    
    return Put({ url: `v1/auth/setPassword/${verifyData}`,payload })
  }

  export const getAdminDetailsAPI = async () => {
    return Get({ url: `v1/user/getAdmin`})
  }

  export const ForgoPasswordMailAPI = async (payload: any) => {
    console.log(payload,"payload>>>>>");
    return Post({ url: `v1/auth/forgotPasswordInitiate`, payload })
  }

  export const ForgoPasswordChangeAPI = async (token:any,payload: any) => {
    console.log(payload,"payload>>>>>");
    return Post({ url: `v1/auth/forgotPassword/${token}`, payload })
  }

  export const logOutAPI = async (payload: any) => {
    console.log(payload,"payload>>>>>");
    
    return Post({ url: `v1/auth/logout`, payload })
  } 
  
 	
